<template>
  <div>
    <BaseStepper class="my-1" :steps="steps" @stepChanged="updateCurrentStep" />
    <BaseAlert
      color="var(--red-100)"
      class="quote-error-message mx-4 pa-4"
      v-if="quoteFailed"
    >
      <div class="d-flex flex-no-wrap error-message">
        <div class="mr-3">
          <v-icon color="var(--red-500)">mdi-alert-circle</v-icon>
        </div>
        <div>
          <span class="font-weight-bold">Sorry!</span>
          We couldn't get a quote right now, please try again in a few minutes.
        </div>
      </div>
    </BaseAlert>

    <BaseAlert
      color="var(--red-100)"
      class="quote-error-message mx-4 pa-4"
      v-if="quoteDeclined"
    >
      <div class="d-flex flex-no-wrap error-message">
        <div class="mr-3">
          <v-icon color="var(--red-500)">mdi-alert-circle</v-icon>
        </div>
        <div>
          <span class="font-weight-bold">Sorry!</span> Unfortunately no insurer
          was able to offer you a quote at this time based on the details you
          have entered.
        </div>
      </div>
    </BaseAlert>

    <BaseAlert
      color="var(--red-100)"
      class="quote-error-message mx-4 pa-4"
      v-if="clientError"
    >
      <div class="d-flex flex-no-wrap error-message">
        <div class="mr-3">
          <v-icon color="var(--red-500)">mdi-alert-circle</v-icon>
        </div>
        <div>
          <span class="font-weight-bold">Sorry!</span> There is a problem with
          the following questions:
          <ul>
            <li
              v-for="(message, index) in clientErrorMessagesArray"
              :key="index"
              class="font-weight-bold"
            >
              {{ message }}
            </li>
          </ul>
        </div>
      </div>
    </BaseAlert>

    <div
      :class="[
        currentStep?.stepNumber === 3
          ? ''
          : 'white rounded-lg elevation-3 ma-3 pa-lg-8 pa-3',
      ]"
    >
      <router-view />
    </div>
  </div>
</template>

<script>
import BaseStepper from "@/components/BaseComponents/BaseStepper";
import BaseAlert from "@/components/BaseComponents/BaseAlert";
import { mapState, mapGetters } from "vuex";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { FAILED, UNABLE, CLIENTERROR } from "@/constants/common.constants";
import { ROUTE_NAME } from "@/constants/route.constants";

export default {
  name: "LandlordsB2BQuestionsLayout",
  components: {
    BaseStepper,
    BaseAlert,
  },
  data() {
    return {
      steps: [
        {
          stepNumber: 1,
          label: "Your details",
          routeName: ROUTE_NAME.LANDLORDS.B2B.YOUR_DETAILS,
        },
        {
          stepNumber: 2,
          label: "Property details",
          routeName: ROUTE_NAME.LANDLORDS.B2B.PROPERTY_DETAILS,
        },
        {
          stepNumber: 3,
          label: "Your quotes",
          routeName: ROUTE_NAME.LANDLORDS.B2B.QUOTATION_RESULT,
        },
      ],
      currentStep: null,
    };
  },
  watch: {
    quoteFailed(val) {
      if (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    quoteDeclined(val) {
      if (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    clientError(val) {
      if (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, ["lastQuoteErrorType"]),
    ...mapGetters(QUESTIONS_MODULE, ["clientErrorMessagesArray"]),
    quoteFailed() {
      return this.lastQuoteErrorType === FAILED;
    },
    quoteDeclined() {
      return this.lastQuoteErrorType === UNABLE;
    },
    clientError() {
      return this.lastQuoteErrorType === CLIENTERROR;
    },
  },
  methods: {
    updateCurrentStep(step) {
      this.currentStep = step;
    },
  },
};
</script>
